import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const TESTIMONIALS_DEFAULTS = {
    items: [
        {
            id: "t1",
            quote: "EmBuilder cut our landing page turnaround from days to minutes. The static output is a dream to host.",
            authorName: "Alex Rivera",
            authorRole: "CTO, Nimbus",
            avatarUrl: "https://placehold.co/96x96/e5e7eb/6b7280?text=A",
            rating: 5,
        },
        {
            id: "t2",
            quote: "Finally a builder that doesn't fight me. The zero-runtime approach keeps our Lighthouse scores pristine.",
            authorName: "Sam Ngozi",
            authorRole: "Head of Growth, Ply",
            avatarUrl: "https://placehold.co/96x96/e5e7eb/6b7280?text=S",
            rating: 5,
        },
        {
            id: "t3",
            quote: "The inspector is faster than any no-code tool I've used. My non-technical teammates ship alongside me.",
            authorName: "Priya Das",
            authorRole: "Founder, Loophole",
            avatarUrl: "https://placehold.co/96x96/e5e7eb/6b7280?text=P",
            rating: 5,
        },
    ],
    columns: 3,
    style: "card",
    background: "transparent",
    cardBackground: "#ffffff",
    textColor: "#0f172a",
    accent: "#f59e0b",
};
function renderStars(n, accent) {
    if (!n)
        return "";
    const filled = Math.max(0, Math.min(5, Math.round(n)));
    const stars = Array.from({ length: 5 }, (_, i) => i < filled
        ? `<span style="color:${accent}">★</span>`
        : `<span style="color:#e5e7eb">★</span>`).join("");
    return `<div class="emk-testimonial-rating" aria-label="${filled} out of 5 stars" style="font-size:16px;letter-spacing:2px;margin-bottom:12px">${stars}</div>`;
}
export const testimonialsWidget = {
    type: "testimonials",
    defaultProps: TESTIMONIALS_DEFAULTS,
    renderHtml(props, ctx) {
        const items = props.items ?? [];
        if (items.length === 0) {
            return `<div class="emk-testimonials" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty testimonials — add items in the inspector)</div>`;
        }
        const cols = props.columns ?? 3;
        const style = props.style ?? "card";
        const bg = props.background ?? "transparent";
        const cardBg = props.cardBackground ?? "#ffffff";
        const text = props.textColor ?? "#0f172a";
        const accent = props.accent ?? "#f59e0b";
        const gridStyle = [
            "display:grid",
            `grid-template-columns:repeat(${cols},minmax(0,1fr))`,
            "gap:20px",
            "max-width:1200px",
            "margin:0 auto",
            "font-family:inherit",
        ].join(";");
        const cards = items
            .map((it) => {
            const cardStyle = style === "card"
                ? `display:flex;flex-direction:column;padding:24px;border-radius:12px;background:${cardBg};color:${text};border:1px solid rgba(0,0,0,0.08)`
                : `display:flex;flex-direction:column;padding:12px 4px;color:${text}`;
            const avatar = it.avatarUrl
                ? `<img src="${escapeAttr(ctx.resolveAssetUrl?.(it.avatarUrl) ?? it.avatarUrl)}" alt="" loading="lazy" decoding="async" style="width:44px;height:44px;border-radius:50%;object-fit:cover;flex-shrink:0">`
                : `<div aria-hidden="true" style="width:44px;height:44px;border-radius:50%;background:${accent}22;display:flex;align-items:center;justify-content:center;color:${accent};font-weight:600;font-size:16px">${escapeHtml((it.authorName || "?").charAt(0).toUpperCase())}</div>`;
            const role = it.authorRole
                ? `<div style="font-size:13px;opacity:0.7;line-height:1.3">${escapeHtml(it.authorRole)}</div>`
                : "";
            const stars = renderStars(it.rating ?? 0, accent);
            return `<figure class="emk-testimonial" style="${cardStyle};margin:0">${stars}<blockquote style="margin:0 0 18px;font-size:16px;line-height:1.6;flex:1">"${escapeHtml(it.quote)}"</blockquote><figcaption style="display:flex;align-items:center;gap:12px;margin:0">${avatar}<div style="line-height:1.3"><div style="font-weight:600;font-size:14px">${escapeHtml(it.authorName)}</div>${role}</div></figcaption></figure>`;
        })
            .join("");
        return `<div class="emk-testimonials" style="background:${bg};padding:20px 0"><div style="${gridStyle}">${cards}</div></div>`;
    },
};
//# sourceMappingURL=testimonials.js.map